import React from 'react';
import { withYMaps } from 'react-yandex-maps';
import {
  object, func, shape,
} from 'prop-types';
import { renderToString } from 'react-dom/server';

import s from './index.module.css';
import { ReactComponent as MyPlaceIcon } from '../assets/my-place.svg';

const fullScreenButton =  
  <div className={s.container}>
    <button type="button" className={s.geolocationButton}>
      <MyPlaceIcon width={20} height={20}/>
    </button>
  </div>

const TemplateProvider = ({ ymaps, children }) => {
  const zoomLayout = ymaps.templateLayoutFactory.createClass(
    renderToString(fullScreenButton), {}
  );

  return children({ template: zoomLayout });
}

TemplateProvider.propTypes = {
  children: func,
  ymaps: shape({ templateLayoutFactory: object }),
};

TemplateProvider.defaultProps = {
  children: null,
  ymaps: null
};

const GeolocationTemplateProvider = withYMaps(TemplateProvider, true, [
  'templateLayoutFactory',
]);

export default GeolocationTemplateProvider;